export default {"src":"/planos/_next/static/media/equifax-money-bag-data.3c96b79a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};